"use client";

import { useQuery } from "@tanstack/react-query";
import { browserCoreApi } from "@/lib/api";
import { playlistKeys, sharedPlaylistKeys } from "./query-keys";

export function usePlaylist(id: number) {
  return useQuery({
    queryKey: playlistKeys.detail(id),
    queryFn: ({ signal }) => browserCoreApi.playlists.detail(id, signal),
  });
}

export function usePlaylistSongs(id: number) {
  return useQuery({
    queryKey: playlistKeys.songs(id),
    queryFn: ({ signal }) => browserCoreApi.playlists.songs(id, { limit: 200 }, signal),
  });
}

export function useSharedPlaylist(token: string) {
  return useQuery({
    queryKey: sharedPlaylistKeys.detail(token),
    queryFn: ({ signal }) => browserCoreApi.userPlaylists.bySharedToken(token, signal),
    enabled: Boolean(token),
  });
}

export function useSharedPlaylistItems(token: string) {
  return useQuery({
    queryKey: sharedPlaylistKeys.items(token),
    queryFn: ({ signal }) => browserCoreApi.userPlaylists.sharedItems(token, signal),
    enabled: Boolean(token),
  });
}
